import Vue from "vue";
import VueRouter from "vue-router";
import Clients from "@/views/Clients";
import Results from "@/views/Results";
import Tests from "@/views/Tests";
// import AdminMarkers from "@/views/AdminMarkers";
// import AdminKits from "@/views/AdminKits";
//import AdminLab from "@/views/AdminLab";
import Login from "@/views/Login";
import firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/admin/lab",
    name: "AdminLab",
    // component: AdminLab,
    component: () => import(/* webpackChunkName: "admin" */ "@/views/AdminLab"),
    meta: {
      protected: true
    }
  },
  {
    path: "/admin/markers",
    name: "AdminMarkers",
    // component: AdminMarkers,
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/AdminMarkers"),
    meta: {
      protected: true
    }
  },
  {
    path: "/admin/kits/:kitId?",
    name: "AdminKits",
    // component: AdminKits,
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/AdminKits"),
    props: true,
    meta: {
      protected: true
    }
  },
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      protected: false
    }
  },
  {
    path: "/clients",
    name: "Clients",
    component: Clients,
    meta: {
      protected: true
    }
  },
  {
    path: "/clients/results/:clientId",
    name: "Results",
    component: Results,
    props: true,
    meta: {
      protected: true
    }
  },
  {
    path: "/tests",
    name: "Tests",
    component: Tests,
    meta: {
      protected: true
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {
      protected: true
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.protected);

  // console.log("beforeeach", currentUser, requiresAuth);

  if (requiresAuth && !currentUser) {
    const loginpath = window.location.pathname;
    next({ name: "Login", query: { from: loginpath } });
  } else next();
});

export default router;
